import { formatDateString } from 'tsx/libs/dayjs';

import { buildColumn, EditableColumnConfig } from '~components/table-view';

const commonColumnsList: EditableColumnConfig[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'start_time',
    header: 'Time',
    type: 'text',
  },
];

const notLoggedInColumnsList: EditableColumnConfig[] = [
  {
    id: 'full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'last_login',
    header: 'Last Login',
    type: 'text',
    accessorFn: (row) => (row.last_login ? formatDateString(row.last_login) : 'Never Logged In'),
  },
];

export const commonColumns = commonColumnsList.map(buildColumn);
export const notLoggedInColumns = notLoggedInColumnsList.map(buildColumn);
